import { render } from "./CollapsibleComponent.vue?vue&type=template&id=705baba4&scoped=true"
import script from "./CollapsibleComponent.vue?vue&type=script&lang=js"
export * from "./CollapsibleComponent.vue?vue&type=script&lang=js"

import "./CollapsibleComponent.vue?vue&type=style&index=0&id=705baba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705baba4"]])

export default __exports__